import { styled, TableCell } from "@mui/material";

export const MyHeadCellLeftStyled = styled(TableCell)(
    ({ theme }) => ({
        color: theme.palette.primary.contrastText,
        borderTopLeftRadius: theme.shape.borderRadius
    })
);